module.exports = __webpack_public_path__ + "img/interstitial_3.15b85458.jpg";